import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = (): null => {
  const { pathname } = useLocation();

  useEffect(() => {
    // workaround for mobile views to scroll correctly is to set overflow to hidden temporarily and then restore it
    const { overflow } = document.documentElement.style;
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
    });
    document.documentElement.style.overflow = overflow;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
